import { render, staticRenderFns } from "./DarkSideBar.vue?vue&type=template&id=18ed15ba"
import script from "./DarkSideBar.vue?vue&type=script&lang=js"
export * from "./DarkSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports